import React, {useEffect, useState} from "react";
import {Select, Typography} from "antd";

// A free multi-value field is an array even when its display text contains
// punctuation. Select's tags mode commits each item with Enter.
export default function MetadataEntityMultiValueEditor({name, values, editable, onChange, onStart}) {
    const rawValues = (Array.isArray(values) ? values : [values])
        .filter(value => value !== null && value !== undefined && value !== '');
    const [pending, setPending] = useState(rawValues);
    useEffect(() => setPending(rawValues), [values]);

    if (!editable) return <Typography.Text>{rawValues.join(", ")}</Typography.Text>;

    const strings = pending.map(String);
    const handleChange = selected => {
        const next = selected.map(value => pending.find(original => String(original) === value) ?? value);
        setPending(next);
        onChange(next);
    };

    return <Select
        aria-label={name}
        mode="tags"
        allowClear
        onFocus={onStart}
        onChange={handleChange}
        open={false}
        tokenSeparators={[]}
        value={strings}
        getPopupContainer={trigger => trigger.parentElement}
        style={{minWidth: 180, maxWidth: "100%"}}
    />;
}
